import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTopic = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Medium",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_985",
				"data-name": "Rectangle 985",
				width: 80,
				height: 80,
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_812",
				"data-name": "Path 812",
				d: "M0,0S21.238,8.007,42.279,8.007,84.161,0,84.161,0V17.429H0Z",
				transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 48.273)",
				fill: "#fff"
			})
		})] }),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_851",
			"data-name": "Path 851",
			d: "M40.292,7.593c17.526,0,36.258,1.29,25.457,12.034C62.757,22.6,59.909,30,59.449,39.3c-.382,7.7-17.076,6.077-20.337,6.973s-12.89,8.171-20.1,6.77C16.136,49.3,2.5,39.922.642,37.406-8.214,25.4-.5,25.424-2.6,18.274S4.2,15.6,5.744,12.521C9.717,4.6,11.129-7.665,11.144-8,14.8-29.007,23.03,7.593,40.292,7.593Z",
			transform: "translate(9.33 17.992)",
			fill: "rgba(83,154,133,0.15)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Placeholders_Topic_Large",
			"data-name": "Placeholders/Topic/Large",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_5006",
				"data-name": "Group 5006",
				transform: "translate(-1.233 2.405)",
				children: [
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse_85",
						"data-name": "Ellipse 85",
						cx: 41.039,
						cy: 11.458,
						rx: 41.039,
						ry: 11.458,
						transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 50.288)",
						fill: "#f6f6f6"
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_86",
						"data-name": "Ellipse 86",
						cx: 26.522,
						cy: 26.522,
						r: 26.522,
						transform: "translate(13.243 8.604)",
						fill: "#1e74a6"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Mask_Group_16",
						"data-name": "Mask Group 16",
						transform: "translate(3.927 9.83)",
						clipPath: "url(#clip-path-2)",
						children: [
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_87",
								"data-name": "Ellipse 87",
								cx: 41.039,
								cy: 11.458,
								rx: 41.039,
								ry: 11.458,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -2.731, 41.936)",
								fill: "#c3c3c3"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_88",
								"data-name": "Ellipse 88",
								cx: 41.039,
								cy: 11.458,
								rx: 41.039,
								ry: 11.458,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -3.927, 40.259)",
								fill: "#f6f6f6"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_95",
								"data-name": "Ellipse 95",
								cx: 41.039,
								cy: 9.67,
								rx: 41.039,
								ry: 9.67,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -2.697, 42.016)",
								fill: "#e5e5e5"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_96",
								"data-name": "Ellipse 96",
								cx: 41.039,
								cy: 9.313,
								rx: 41.039,
								ry: 9.313,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -2.697, 42.016)",
								fill: "#f6f6f6"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_97",
								"data-name": "Ellipse 97",
								cx: 41.039,
								cy: 9.67,
								rx: 41.039,
								ry: 9.67,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -3.412, 41.301)",
								fill: "#e5e5e5"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_98",
								"data-name": "Ellipse 98",
								cx: 41.039,
								cy: 9.313,
								rx: 41.039,
								ry: 9.313,
								transform: "matrix(0.819, -0.574, 0.574, 0.819, -3.412, 41.301)",
								fill: "#f6f6f6"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_847",
						"data-name": "Path 847",
						d: "M25.456,0C37.892,0,45.691,10.745,47.392,15.346c4.908,13.279-11.531-2.5-22.747-2.291s-31.124,11.8-22.566-.892A28.365,28.365,0,0,1,25.456,0Z",
						transform: "matrix(0.819, -0.574, 0.574, 0.819, 5.418, 27.694)",
						fill: "rgba(255,255,255,0.18)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_848",
						"data-name": "Path 848",
						d: "M21.5,0C32.01,0,38.6,9.077,40.035,12.964c4.146,11.218-9.741-2.11-19.216-1.935S-5.473,21,1.757,10.275A23.961,23.961,0,0,1,21.5,0Z",
						transform: "translate(10.579 23.299) rotate(-31)",
						fill: "rgba(255,255,255,0.18)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_849",
						"data-name": "Path 849",
						d: "M17.144,0c8.376,0,13.628,4.871,14.773,6.957,3.306,6.02-7.766-1.133-15.319-1.039s-20.961,5.35-15.2-.4C3.5,3.415,8.768,0,17.144,0Z",
						transform: "matrix(-0.866, 0.5, -0.5, -0.866, 66.687, 48.439)",
						fill: "#1a6a9a"
					})
				]
			})
		})
	]
});
export default SvgTopic;
